// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1PkIz","notes":"Notes_notes__3uign"};